<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <v-col cols="12">
          <BaseCard
            title="Add Sales Team"
            icon="mdi-account-group"
            vCardTextClass="pa-2"
          >
            <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
              <v-row>
                <v-col md="3" cols="12">
                  <v-card elevation="0" border rounded="lg" class="pa-2 h-100">
                    <div class="d-flex align-center mb-4">
                      <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                        <v-icon size="20">mdi-information-outline</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-medium">Main details</div>
                        <div class="text-caption text-medium-emphasis">Provide main information</div>
                      </div>
                    </div>
                    <v-row dense>
                      <v-col cols="12">
                        <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="department_id.value.value"
                          :items="getHrmDepartmentList"
                          :item-title="(item) => `${item.name}`"
                          item-value="id"
                          @update:modelValue="onDepartmentChange"
                          :error-messages="department_id.errorMessage.value"
                          autocomplete="off"
                          :loading="deparment_loading"
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
                          clearable
                        >
                          <template #label>
                            Department <span class="text-red-accent-4">*</span>
                          </template>
                        </v-autocomplete>

                        <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="team_name.value.value"
                          :error-messages="team_name.errorMessage.value"
                          autocomplete="off"
                          clearable
                        >
                          <template #label>
                            Team Name <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>

                <v-col class="pl-0" md="9" cols="12">
                  <v-card elevation="0" border rounded="lg">
                    <div class="d-flex align-center py-2 px-3">
                      <v-avatar color="primary" variant="tonal" size="36" class="me-2">
                        <v-icon size="20">mdi-account-multiple-outline</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-1 font-weight-medium">Sales team details</div>
                        <div class="text-caption text-medium-emphasis">
                          Search and add team members
                        </div>
                      </div>
                    </div>

                    <v-row class="px-4" justify="center">
                      <v-col cols="12" md="9" lg="8">
                        <v-autocomplete
                          label="Search Employee Name"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="employee_id.value.value"
                          :items="getHrmEmployeeList"
                          :item-title="(item) => `${item.code}-${item.name}` ?? 'N/A'"
                          item-value="id"
                          :error-messages="employee_id.errorMessage.value"
                          autocomplete="off"
                          @update:model-value="addEmployee"
                          @keydown.enter="addEmployee"
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" class="overflow-x-auto">
                          <v-table
                            density="compact"
                            :loading="loading"
                            fixed-header
                            style="max-height: 600px; overflow-y: scroll"
                          >
                            <thead>
                              <tr>
                                <th class="text-center">SL</th>
                                <th class="text-left" style="width: 30%">Name</th>
                                <th class="text-left" style="width: 20%">Code</th>
                                <th class="text-center" style="width: 25%">Designation</th>
                                <th class="text-center" style="width: 20%">Employee Type</th>
                                <th class="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(item, index) in cart"
                                v-if="cart.length > 0"
                                :key="index"
                              >
                                <td class="text-center">{{ index + 1 }}</td>
                                <td class="text-left px-1" style="white-space: normal">
                                  {{ item.name }}
                                </td>
                                <td class="text-left px-1" style="white-space: normal">
                                  {{ item.code }}
                                </td>
                                <td class="text-center px-1">{{ item.designation }}</td>
                                <td class="text-center px-1">{{ item.employee_type }}</td>
                                <td class="text-center px-1">
                                  <v-btn
                                    icon="mdi-delete-outline"
                                    size="small"
                                    color="error"
                                    variant="text"
                                    @click="removeFromCart(index)"
                                  ></v-btn>
                                </td>
                              </tr>
                              <tr v-else>
                                <td colspan="6" class="text-center py-8">
                                  <v-icon size="32" color="primary" class="mb-2">
                                    mdi-account-group-outline
                                  </v-icon>
                                  <div class="text-body-2 text-medium-emphasis">
                                    No team member selected
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </v-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>

            <v-divider class="mt-2"></v-divider>
            <v-card-actions>
              <v-row align="start">
                <v-col cols="12" md="8">
                  <v-textarea
                    label="Remarks"
                    density="compact"
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="remarks.value.value"
                    :error-messages="remarks.errorMessage.value"
                    autocomplete="off"
                    rows="3"
                    clearable
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="d-flex justify-end ga-2">
                    <v-btn
                      color="grey-darken-1"
                      variant="flat"
                      prepend-icon="mdi-content-save-outline"
                      @click="submitForm(0)"
                    >
                      Draft
                    </v-btn>
                    <v-btn
                      color="primary"
                      variant="flat"
                      prepend-icon="mdi-content-save-outline"
                      @click="submitForm(1)"
                    >
                      Save
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </BaseCard>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import BaseCard from "@/components/utils/baseCard.vue";

export default {
  components: {
    BaseCard,
  },
  data: () => ({
    loading: false,
    errorMessages: "",
    visible: false,
    search: "",
    deparment_loading: false,
    employee_loading: false,
    cart: [],
  }),
  watch: {},
  created() {
    this.deparment_loading = true;
    this.$store.dispatch("getHrmDepartmentList").then(() => {
      this.deparment_loading = false;
    });
    this.employee_loading = true;
    this.$store.dispatch("getHrmEmployeeList").then(() => {
      this.employee_loading = false;
    });
  },
  computed: {
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
  },
  methods: {
    async onDepartmentChange(selectedId) {
      if (!selectedId) {
        this.department_id.value.value = null;
        return;
      }

      try {
        await this.$store.dispatch("getHrmEmployeeList", {
          params: { department_id: selectedId },
        });
      } catch (error) {
        console.error("Failed to load employee data:", error);
      }
    },
    addEmployee() {
      const selectedEmployeeId = this.employee_id.value?.value;
      if (!selectedEmployeeId) {
        toast.error("Please select a Employee");
        this.cartReset();
        return false;
      }

      const cartInd = this.cart.findIndex(
        (p) => p.employee_id === selectedEmployeeId
      );

      if (cartInd > -1) {
        toast.error("Employee already added in List");
        this.cartReset();
        return false;
      }

      const employeeMap = this.getHrmEmployeeList.find(
        (item) => item.id == selectedEmployeeId
      );

      this.cart.push({
        employee_id: selectedEmployeeId,
        name: employeeMap?.name || "",
        code: employeeMap?.code || "",
        designation: employeeMap?.designation?.name || "",
        employee_type: employeeMap?.employee_type?.name || "",
      });
      this.$nextTick(() => {
        this.cartReset();
      });
    },
    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },
    cartReset() {
      this.employee_id.value.value = null;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        team_name: yup.string().min(3).max(150).required().label("Team Name"),
        department_id: yup.string().required().label("Department Name"),
      }),
    });

    const employee_id = useField("employee_id");
    const team_member_master_id = useField("team_member_master_id");
    const team_name = useField("team_name");
    const department_id = useField("department_id");
    const team_members = useField("team_members");
    const remarks = useField("remarks");

    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("Save");
    const store = useStore();
    const router = useRouter();
    const currentStatus = ref(0);
    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      values.status = currentStatus.value;
      const employeeIds = cart.value.map((item) => item.employee_id);
      values.team_members = employeeIds;

      if (values.team_members.length === 0) {
        toast.error("Team member is required.");
        return false;
      }

      store
        .dispatch("saveUpdateSalesTeam", values)
        .then((response) => {
          resetForm();
          cart.value = [];
          buttonText.value = "Save";
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "sales-team-list" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      team_member_master_id,
      team_name,
      department_id,
      team_members,
      employee_id,
      remarks,
      cart,
      errorMessages,
      buttonText,
      loading,
    };
  },
  mounted() {
    this.employee_id.value.value = null;

    if (this.$store.getters.getEditingSalesTeams) {
      this.$store.commit("SET_LOADING", { color: "primary" });
      const data = this.$store.getters.getEditingSalesTeams;
      this.team_member_master_id.value.value = data.id;
      this.department_id.value.value = data.department_id;
      this.isEntryMode = false;
      this.team_name.value.value = data.team_name;

      if (data.team_members && data.team_members.length > 0) {
        this.cart = data.team_members.map((member) => {
          const emp = member.employee || {};
          return {
            employee_id: member.employee_id,
            name: emp.name || "",
            code: emp.code || "",
            designation: emp.designation?.name || "",
            employee_type: emp.employee_type?.name || "",
          };
        });
        this.$store.commit("UNSET_LOADING");
      } else {
        this.cart = [];
      }
    } else {
      this.$store.commit("setEditingSalesTeams", null);
    }
  },
  beforeUnmount() {
    this.$store.commit("setEditingSalesTeams", null);
  },
};
</script>
